/* eslint-disable @typescript-eslint/no-explicit-any */
export function combineItemArrays(data: any, keys: any) {
  const result: any = [];

  // Iterate over each key in the input data
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const items = data[key];

    // Iterate through each item in the array
    for (let j = 0; j < items.length; j++) {
      const row = items[j].row_number;

      // Initialize the array entry if it doesn't exist yet
      if (!result[row - 1]) {
        result[row - 1] = {};
      }

      // Dynamically assign item to the corresponding row_number
      result[row - 1][key] = items[j];
    }
  }

  return result;
}
